import { render, staticRenderFns } from "./CssFusion.vue?vue&type=template&id=708cc243&scoped=true&"
import script from "./CssFusion.vue?vue&type=script&lang=js&"
export * from "./CssFusion.vue?vue&type=script&lang=js&"
import style0 from "./CssFusion.vue?vue&type=style&index=0&id=708cc243&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cc243",
  null
  
)

export default component.exports